import { FormControl } from "@mui/material";
import MUIRadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import { isEmpty } from "lodash";
import { type FC, type PropsWithChildren } from "react";
import { useController } from "react-hook-form";
import * as StyledCommon from "./Common.styled";
import { FormError } from "./FormError";

export type RadioGroupProps = PropsWithChildren<{
    name: string;
    label?: string;
}>;

export const RadioGroup: FC<RadioGroupProps> = ({ children, label, name }) => {
    const { fieldState } = useController({ name });
    const { error } = fieldState;

    return (
        <Stack>
            {!isEmpty(label) && <StyledCommon.InputLabel>{label}</StyledCommon.InputLabel>}
            <FormControl>
                <MUIRadioGroup aria-labelledby={`radio-buttons-group-${name}`}>{children}</MUIRadioGroup>
            </FormControl>
            <FormError error={error} fieldName={name} />
        </Stack>
    );
};
